import { render, staticRenderFns } from "./comp-resumo-consultor.vue?vue&type=template&id=7670b7aa&scoped=true"
import script from "./comp-resumo-consultor.vue?vue&type=script&lang=js"
export * from "./comp-resumo-consultor.vue?vue&type=script&lang=js"
import style0 from "./comp-resumo-consultor.vue?vue&type=style&index=0&id=7670b7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670b7aa",
  null
  
)

export default component.exports